import { i18n } from "@lingui/core"

import { Locale, LOCALES } from "../utils/locales/constants"

export interface LocalizedPageContext {
  locale: Locale
  commonCatalog: Dictionary<string>
  pageCatalog: Dictionary<string>
}

const emptyCatalogInitialState = LOCALES.reduce(
  (acc, locale) => {
    acc[locale] = {}
    return acc
  },
  {} as Record<Locale, Dictionary<string>>,
)

i18n.load(emptyCatalogInitialState)

export { i18n }

/**
 * Determine the page namespace from the pathname
 * Supports nested paths like /catalog/apple-gift-cards/
 * @param nonLocalizedPathname - The pathname without the locale prefix
 */
export function getPageNamespace(
  nonLocalizedPathname: string,
): string | undefined {
  if (nonLocalizedPathname === "/") {
    return "__root_path__"
  }

  // Remove leading and trailing slashes and split by /
  const parts = nonLocalizedPathname.replace(/^\/|\/$/g, "").split("/")

  // For nested paths, just return the top-level directory or path
  // Ex: "/catalog/apple-gift-cards/" → "catalog"
  // Ex: "/de/catalog/apple-gift-cards/" → "catalog"
  const namespace = parts[0]

  // Temporary fix for pages that we don't want to translate, but get covered by the catalog namespace.
  // TODO: Remove this when we move these pages to Dato.
  const catalogIgnoredSubpages = [
    "walmart-gift-cards",
    "uber-gift-cards",
    "itunes-gift-cards",
    "the-home-depot-gift-cards",
    "gamestop-gift-cards",
    "ebay-gift-cards",
    "best-buy-gift-cards",
    "google-play-gift-cards",
    "apple-gift-cards",
  ].map(subpage => `/catalog/${subpage}`)

  if (catalogIgnoredSubpages.includes(nonLocalizedPathname)) {
    return undefined
  }

  return namespace
}
